import {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useState,
} from 'react';

export type SignInContextType = {
  modalErrors: string[];
  setModalErrors: Dispatch<SetStateAction<string[]>>;
  handleModalClose: () => void;
};

export const SignInContext = createContext<SignInContextType>(
  {} as SignInContextType,
);

export const SignInProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const [modalErrors, setModalErrors] = useState<string[]>([]);

  const handleModalClose = () => {
    setModalErrors([]);
  };

  return (
    <SignInContext.Provider
      value={{ modalErrors, setModalErrors, handleModalClose }}
    >
      {children}
    </SignInContext.Provider>
  );
};

export const useSignInModalError = () => {
  const context = useContext(SignInContext);

  if (!context) {
    throw new Error('useModalErrors hook must be used under SignInProvider');
  }

  return context;
};
